import React from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";

const DocumentDeleteModal = ({ document, showModal, setShowModal, fetchDocuments, setShowToast, setToastInfo }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? null : date;
  };

  const formatDocument = (document) => {
    return {
      name: document.name || "",
      docType: document.metadata.docType || "",
      propertyId: document.metadata.propertyId || "",
      containerName: document.containerName || "Unknown",
      expirationDate: formatDate(document.metadata.expirationDate) || undefined,
      state: document.metadata.state || "",
      county: document.metadata.county || "",
      saleDate: formatDate(document.metadata.saleDate) || undefined,
      saleId: document.metadata.saleId || "",
    };
  };

  const handleDelete = async () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const documentToDelete = formatDocument(document);
    try {
      const API_BASE_URL = process.env.REACT_APP_SERVER_URL;
      const API_KEY = process.env.REACT_APP_SERVER_API_KEY;
      const response = await axios.delete(
        `${API_BASE_URL}/blob/container/${documentToDelete.containerName}/blob/${documentToDelete.name}`,
        {
          metadata: {
            ...documentToDelete,
            expirationDate: yesterday.toISOString().split("T")[0], // Set expiration date to yesterday
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "x-api-key": API_KEY,
          },
        }
      );
      if (response.status === 200) {
        setShowToast(true);
        setToastInfo({
          header: "Success",
          body: `Successfully deleted ${documentToDelete.name}`,
          variant: "warning"
        });
        setShowModal(false);
        fetchDocuments(); // Refresh after "deletion"
      }
      //   onHide(); // Close the modal
    } catch (error) {
      console.error('Error "deleting" document by setting expiration:', error);
      setShowToast(true);
      setToastInfo({
        header: "Error",
        body: `There was an error with deleting ${documentToDelete.name}`,
        variant: "danger"
      });
    }
  };

  return (
    <Modal show={showModal}>
      <Modal.Body>
        <div>
          <p className="text-center">Are you sure you want to delete the following document?</p>
          <p className="text-center">
            This document will be <em>permanently</em> deleted.
          </p>
        </div>
        <p className="text-center">
          <strong>{document.name}</strong>
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-evenly">
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Close
        </Button>
        <Button variant="danger" onClick={() => handleDelete()}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentDeleteModal;
